import { CSSObject } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import { MantineThemeComponent } from '../../types';

const SelectDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		drop: 'bottom-start'
	},
	styles: {
		input: {
			...( textVariants.body as CSSObject ),
			'color': 'var(--color-text-primary)',
			'border': '1px solid var(--color-outline-default)',
			'backgroundColor': 'var(--color-bg-surface)',
			'borderRadius': '4px',
			'padding': '4px 8px',
			'&::placeholder': {
				...( textVariants.body as CSSObject )
			}
		},
		values: {
			'minHeight': '34px'
		},
		value: {
			'backgroundColor': 'var(--color-primary-subtle)',
			'color': 'var(--color-primary-base)',
			'border': '1px solid var(--color-primary-base)'
		},
		label: {
			...( textVariants[ 'body-bold' ] as CSSObject ),
			color: 'var(--color-text-primary)',
			marginBottom: 8
		},
		item: {
			...( textVariants.body as CSSObject ),
			'color': 'var(--color-text-primary)',
			'&[data-hovered]': { backgroundColor: 'var(--color-primary-subtle)' }
		},
		wrapper: {
			'pointerEvents': 'all'
		},
		dropdown: {
			'border': '1px solid var(--color-outline-default)',
			'backgroundColor': 'var(--color-bg-surface-dim)',
			'marginTop': -4,
			'borderRadius': '4px'
		}
	}
};

export default SelectDefaultConfig;
